var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.optLoading,
          expression: "optLoading",
        },
      ],
      staticClass: "view-contanier",
    },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "tab" }, [
          _c(
            "span",
            {
              class: ["tabItem", _vm.active === 0 ? "active" : ""],
              on: {
                click: function ($event) {
                  return _vm.changeType(0)
                },
              },
            },
            [_vm._v(" 客户 ")]
          ),
          _c(
            "span",
            {
              class: ["tabItem", _vm.active === 1 ? "active" : ""],
              on: {
                click: function ($event) {
                  return _vm.changeType(1)
                },
              },
            },
            [_vm._v(" 代理 ")]
          ),
        ]),
        _c(
          "div",
          { staticClass: "opt" },
          [
            _vm.filterList.invoiceDate && _vm.isActive
              ? _c("div", { staticClass: "checkDate flex_c_c" }, [
                  _vm._v(
                    " 查询时间：" +
                      _vm._s(
                        _vm.filterList.invoiceDate[0] +
                          "~" +
                          _vm.filterList.invoiceDate[1]
                      ) +
                      " "
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "search" },
              [
                _c(
                  "el-popover",
                  {
                    ref: "popover",
                    staticClass: "searchPop",
                    attrs: {
                      placement: "top",
                      title: "批量搜索",
                      trigger: "click",
                      width: "378",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "close",
                        on: { click: _vm.closeSearchPanel },
                      },
                      [_c("i", { staticClass: "el-icon-close" })]
                    ),
                    _c("base-muti-input", {
                      ref: "baseMutiInput",
                      attrs: { default: _vm.referenceNumber },
                      model: {
                        value: _vm.referenceNumber,
                        callback: function ($$v) {
                          _vm.referenceNumber = $$v
                        },
                        expression: "referenceNumber",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "right",
                          margin: "16px 0 0",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.handleEmpty },
                          },
                          [_vm._v("清空")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "sure",
                            on: { mousedown: _vm.handleConfirm },
                          },
                          [_vm._v("确定")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("el-input", {
                  staticClass: "input-search",
                  attrs: {
                    value: _vm.filterList.search,
                    placeholder: "请输入账单号搜索",
                  },
                  on: { focus: _vm.handleFocus },
                }),
                _c(
                  "div",
                  {
                    staticClass: "btn-search",
                    on: { click: _vm.handleConfirm },
                  },
                  [_c("i", { staticClass: "el-icon-search" })]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "permissson",
                    rawName: "v-permissson",
                    value: "derive",
                    expression: "'derive'",
                  },
                ],
                staticClass: "derive flex_c_c",
                on: { click: _vm.derive },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/const/derive.png"),
                    alt: "导出",
                  },
                }),
                _vm._v(" 导出 "),
              ]
            ),
            _c(
              "BaseFilter",
              {
                attrs: { isActive: _vm.isActive, width: 466 },
                on: { sendFilter: _vm.sendFilter, reset: _vm.reset },
              },
              [
                _c(
                  "div",
                  { staticClass: "filter" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "form",
                        attrs: { model: _vm.filterList, "label-width": "70px" },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "账单状态" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "320px" },
                                attrs: {
                                  filterable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.filterList.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterList, "status", $$v)
                                  },
                                  expression: "filterList.status",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "未审核", value: "0" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "已审核", value: "1" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "业务员" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "320px" },
                                attrs: {
                                  filterable: "",
                                  placeholder: "请选择",
                                  multiple: "",
                                },
                                model: {
                                  value: _vm.filterList.saleIds,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterList, "saleIds", $$v)
                                  },
                                  expression: "filterList.saleIds",
                                },
                              },
                              _vm._l(_vm.userOptions, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "客户" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "320px" },
                                attrs: {
                                  filterable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.filterList.companyId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterList, "companyId", $$v)
                                  },
                                  expression: "filterList.companyId",
                                },
                              },
                              _vm._l(_vm.companyOptions, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "data" },
        [
          _vm.height !== 0
            ? _c("BaseTable", {
                attrs: {
                  height: _vm.height,
                  tableData: {
                    ..._vm.tableData,
                    fileds: _vm.fileds,
                  },
                  pageIndex: _vm.pager.pageIndex,
                  pageSize: _vm.pager.pageSize,
                  loading: _vm.loading,
                  isEmptyBorder: true,
                  pageSizes: [20, 30, 50, 100],
                },
                on: {
                  handlePageChange: _vm.handlePageChange,
                  handleSelectionChange: _vm.handleSelectionChange,
                  sortChange: _vm.sortChange,
                  dblclick: (row) => _vm.detail("FYCX", row),
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "statusName",
                      fn: function (row) {
                        return [
                          row.scope.status === 0
                            ? _c(
                                "div",
                                { staticClass: "flex_c_c status red" },
                                [
                                  _vm._v(
                                    " " + _vm._s(row.scope.statusName) + " "
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                { staticClass: "flex_c_c status green" },
                                [
                                  _vm._v(
                                    " " + _vm._s(row.scope.statusName) + " "
                                  ),
                                ]
                              ),
                        ]
                      },
                    },
                    {
                      key: "verifedAmount",
                      fn: function (row) {
                        return [
                          _vm._v(
                            " " + _vm._s(row.scope.verifedAmount || 0) + "USD "
                          ),
                          +row.scope.verifedAmount > 0
                            ? _c("i", {
                                staticClass: "el-icon-link",
                                staticStyle: { color: "rgb(18, 88, 188)" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showVerifedLog(row.scope)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "opt",
                      fn: function (row) {
                        return [
                          _c(
                            "el-popover",
                            {
                              ref: `popover${row.scope.id}`,
                              attrs: {
                                placement: "bottom-start",
                                "popper-class": "pop-table-opt",
                                width: "114",
                                trigger: "click",
                              },
                            },
                            [
                              _c("div", { staticClass: "table-opt" }, [
                                _c(
                                  "div",
                                  [
                                    !row.scope.status
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permissson",
                                                rawName: "v-permissson",
                                                value: "audit",
                                                expression: "'audit'",
                                              },
                                            ],
                                            staticClass: "opt-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.audit(row.scope)
                                              },
                                            },
                                          },
                                          [_vm._v("审核")]
                                        )
                                      : _vm._e(),
                                    row.scope.status
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permissson",
                                                rawName: "v-permissson",
                                                value: "reAudit",
                                                expression: "'reAudit'",
                                              },
                                            ],
                                            staticClass: "opt-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.reAudit(row.scope)
                                              },
                                            },
                                          },
                                          [_vm._v("反审核")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]),
                              _c("img", {
                                staticStyle: { "margin-left": "-14px" },
                                attrs: {
                                  slot: "reference",
                                  src: require("@/assets/images/table/opt.png"),
                                },
                                slot: "reference",
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "custom-total",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "custom-total" }, [
                            _c("div", { staticStyle: { display: "flex" } }, [
                              _c("div", { staticClass: "select" }, [
                                _vm._v(
                                  "已选 " +
                                    _vm._s(_vm.selectionItem.length) +
                                    " 项"
                                ),
                              ]),
                              _c("div", { staticClass: "total" }, [
                                _vm._v(" 账单金额："),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.totalAmount) + " USD"),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3834464598
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("GenerateBillDialog", {
        attrs: { dialogVisible: _vm.dialogVisible1, type: _vm.active },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible1 = false
          },
          ok: _vm.ok,
        },
      }),
      _c("ShowPayableSupplyDetailDialog", {
        attrs: { rowData: _vm.rowData, dialogFormVisible: _vm.dialogVisible2 },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible2 = false
          },
        },
      }),
      _c("VerifedLogByBillDrawer", {
        attrs: {
          drawer: _vm.drawer,
          rowData: _vm.rowData,
          typeActive: +_vm.active,
        },
        on: {
          close: function ($event) {
            _vm.drawer = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }